import React from 'react'
import i18n from 'simple-react-i18n'
import { nbPerPageLabel, SANDRE } from '../../../../referencial/constants/ReferencialConstants'
import { getLabel, getObjectLabel } from '../../../../utils/StoreUtils'
import { getFullDate } from '../../../../utils/DateUtil'
import { getQualifications, getStatuses, UNQUALIFIED } from '../../../../utils/QualityUtils'
import { getMeasureStatusColorTable } from '../../../../utils/PiezometryUtils'
import PropTypes from 'prop-types'
import DtoHydroMeasures from '../../../dto/chronicMeasures/DtoHydroMeasures'
import { shallowEqual, useSelector } from 'react-redux'
import { getSandreIndexLabel } from '../../../../utils/StringUtil'
import { CardTable } from 'components/datatable/NewTable'
import { IS_INITIAL_POINT } from 'station/constants/StationConstants'
import { isNil, keyBy, max, min, template } from 'lodash'
import { getGeneralLevelling } from '../../../../utils/SettingUtils'

const HYDRO_COTE_NGF = 1

const getSensorValueLabel = (sensor) => {
    if (isNil(sensor?.sensorValue)) {
        return ''
    }
    return sensor.cote === HYDRO_COTE_NGF ? `${sensor.sensorValue} [${getGeneralLevelling()}]` : `${sensor.sensorValue}`
}

const TableViewValidationHydroMode = ({
    selection,
    selectionData,
    setSelectionData,
    measuresData,
    sensorValues = [],
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    setValue,
    setInitialPoint,
}) => {
    const measures = measuresData.map(v => v.measures)

    const {
        contributorsIndex,
        sandreIndex,
    } = useSelector(store => ({
        contributorsIndex: store.ContributorReducer.contributorsIndex,
        sandreIndex: store.ReferencialReducer.sandreIndex,

    }), shallowEqual)

    const measuresBrut = measures[0]
    const qualifications = getQualifications()
    const statuses = getStatuses()
    const sensorByKey = keyBy(sensorValues, s => `${s.date}_${s.codepoint}`)
    const tableMeasures = measuresBrut.map(d => {
        const color = (d.date >= startDate && d.date <= endDate) ? '#7fdde9' : 'white'
        return {
            measure: d,
            date: { value: getFullDate(d.date), color },
            qualification: { value: getLabel(qualifications, d.qualification || UNQUALIFIED), color },
            status: { value: getLabel(statuses, d.status), color: getMeasureStatusColorTable(d.status) },
            initialPoint: { value: d.initialPoint === IS_INITIAL_POINT ? i18n.yes : '', color },
            producer: { value: getObjectLabel(contributorsIndex[d.producer], 'mnemonique'), color },
            value: { value: d.value, color },
            initialValue: { value: d.initialValue, color },
            sensorValue: { value: getSensorValueLabel(sensorByKey[`${d.date}_${d.codepoint}`]), color },
            nature: { value: getSandreIndexLabel(sandreIndex, SANDRE.PIEZOMETER_MEASURE_NATURE, d.nature), color },
        }
    })
    const selectPoint = (point) => {
        if (selection && tableMeasures.length) {
            const date = point.date
            if (selection === 'window') {
                if (selectionData !== 'start') {
                    setSelectionData('start')
                    setStartDate(date)
                    setEndDate(date)
                } else {
                    setSelectionData(null)
                    setStartDate(min([date, startDate]))
                    setEndDate(max([date, startDate]))
                }
            } else if (selection === 'point') {
                setStartDate(date)
                setEndDate(date)
                setValue(point.value)
                setInitialPoint(point.initialPoint)
            }
        }
    }
    return (
        <CardTable
            title={i18n.measures}
            rows={tableMeasures}
            headers={['date', 'value', 'initialValue', { key: 'sensorValue', value: i18n.sensorValue, tooltip: template(i18n.sensorValueHydroTooltip)({ nG: getGeneralLevelling() }) }, 'status', 'qualification', 'nature', 'producer', 'initialPoint']}
            rowsPerPageOptions={nbPerPageLabel}
            onClickRow={m => selectPoint(m.measure)}
            defaultSort={{ column: 'date', direction: 'desc' }}
        />
    )
}
TableViewValidationHydroMode.propTypes = {
    selection: PropTypes.string,
    selectionData: PropTypes.string,
    setSelectionData: PropTypes.func,
    measuresData: PropTypes.arrayOf(PropTypes.instanceOf(DtoHydroMeasures)),
    sensorValues: PropTypes.arrayOf(PropTypes.shape({
        date: PropTypes.number,
        codepoint: PropTypes.number,
        cote: PropTypes.number,
        sensorValue: PropTypes.number,
    })),
    startDate: PropTypes.number,
    endDate: PropTypes.number,
    setStartDate: PropTypes.func,
    setEndDate: PropTypes.func,
    setValue: PropTypes.func,
    setInitialPoint: PropTypes.func,
    setStatus: PropTypes.func,
    setQualification: PropTypes.func,
    setNature: PropTypes.func,
    setMeasureMode: PropTypes.func,
    setProducer: PropTypes.func,
    setManager: PropTypes.func,
    setValidator: PropTypes.func,
}
export default TableViewValidationHydroMode